import { defineMessages } from 'react-intl';

type MessageKeys = 'availableForYouHeading' | 'recommendedAgentsCategory' | 'templatesHeading';

export const messages: Record<
	MessageKeys,
	{ defaultMessage: string; description: string; id: string }
> = defineMessages({
	recommendedAgentsCategory: {
		id: 'agent-studio.landing.recommended-agents.category.ai-non-final',
		defaultMessage: 'Recommended',
		description: 'Label for the browse-agent category that shows recommended agents.',
	},
	availableForYouHeading: {
		id: 'agent-studio.landing.available-for-you.heading.ai-non-final',
		defaultMessage: 'Available for you',
		description:
			'Heading above the list of agents and templates recommended to the user in Atlassian Studio.',
	},
	templatesHeading: {
		id: 'agent-studio.landing.templates.heading.ai-non-final',
		defaultMessage: 'Remix a template',
		description: 'Heading above the list of templates available in Atlassian Studio.',
	},
});
